<template>
    <v-row justify='center' no-gutters>
        <v-col cols="12" md="5" lg="4" sm="10">
            <v-form ref="form" class="form-primary-text">
                <v-row class="row-height-80">
                    <v-col class="col-12">
                        <v-select
                            :items="[1,2,3,4,5,6,7,8,9,10,11,12]"
                            item-value="id"
                            item-text="name"
                            v-model="form.number_of_children"
                            :rules="notNull"
                            label="How many children are in your family? *"
                            outlined
                        ></v-select>
                    </v-col>
                </v-row>
                <v-row v-if="form.number_of_children > 1" justify="center">
                    <v-col class="col-12">
                        <div class="button-group-wrapper text-left">
                            <span>Of all my siblings, I am the: *</span>
                            <v-radio-group v-model="form.eldest_or_youngest" :value="form.eldest_or_youngest" row :rules="[v => v != undefined || v != null||'Please make a selection']">
                                <v-radio color="#ea7f1d" label="Eldest" :value="1" :style="form.eldest_or_youngest == 1 ? 'font-weight: bold;': 'font-weight: normal'"></v-radio>
                                <v-radio color="#ea7f1d" label="Youngest" :value="2" :style="form.eldest_or_youngest == 2 ? 'font-weight: bold;': 'font-weight: normal'"></v-radio>
                                <v-radio color="#ea7f1d" label="Other" :value="3" :style="form.eldest_or_youngest == 3 ? 'font-weight: bold;': 'font-weight: normal'"></v-radio>        
                            </v-radio-group>
                        </div>
                    </v-col>
                </v-row>
                <v-row v-if="form.eldest_or_youngest ===3" class="row-height-80 row-margin-bottom-40">
                    <v-col class="col-12 col-no-up-down-padding">
                        <v-text-field
                            label="Other: Specify where you are in the family *"
                            v-model="form.birth_order"
                            outlined
                            :rules="notNull"
                            hint="e.g. 2 of 5 if you are the second oldest of 5 children"

                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col class="col-12">
                        <div class="button-group-wrapper text-left">
                            <span class="margin-right">Do you have any out-of-home-care experience? *</span>
                            <v-radio-group v-model="form.out_of_home_care" :value="form.out_of_home_care" :rules="[v => v != undefined || v != null||'Please make a selection']" row>
                            <v-radio color="#ea7f1d" label="Yes" :value="1" :style="form.out_of_home_care == 1 ? 'font-weight: bold;': 'font-weight: normal'"></v-radio>
                            <v-radio color="#ea7f1d" label="No" :value="0" :style="form.out_of_home_care == 0 ? 'font-weight: bold;': 'font-weight: normal'"></v-radio>
                            </v-radio-group>
                        </div>
                    </v-col>
                
                </v-row>
                <div v-if="form.out_of_home_care">
                    <v-row>
                        <v-col class="col-12 col-no-up-down-padding" id="abc">
                            <v-textarea
                                outlined
                                name="input-7-2"
                                v-model="form.out_of_home_care_details"
                                placeholder="Please provide any details that you are willing to share about why you were in out-of-home-care and for how long?"
                            ></v-textarea>
                        </v-col>
                    </v-row>
                </div>
                <v-row>
                    <v-col class="col-12 col-no-up-down-padding">
                        <div class="primary-guardian">Who is your primary guardian? *</div>
                        <div class="form-helper-text" style="margin-bottom: 10px">We will contact your Primary Guardian to ask them to endorse your application.</div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-5 col-no-up-down-padding">
                        <!--  :rules="fullString"  -->
                        <v-text-field
                            label="First Name *"
                            :value="form.guardian_first_name"
                            @input="capitalizeString($event, 'guardian_first_name')"
                            :rules="validateNationinput"
                            outlined
                        ></v-text-field>
                    </v-col>
                    <v-col class="col-7 col-no-up-down-padding">
                        <!--  :rules="fullString"  -->
                        <v-text-field
                            label="Last Name *"
                            :value="form.guardian_last_name"
                            @input="capitalizeString($event, 'guardian_last_name')"
                            :rules="validateNationinput"
                            outlined
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-12 col-no-up-down-padding">
                        <v-text-field
                            label="Email *"
                            v-model="form.guardian_email"
                            :rules="validEmail"
                            outlined
                            @select="disableSelection($event)"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-12 col-no-up-down-padding">
                        <v-text-field
                            ref="repeatGuardianEmail"
                            label="Repeat Email *"
                            v-model="repeat_guardian_email"
                            :rules="checkGuardianEmail"
                            outlined
                            @select="disableSelection($event)"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-12">
                        <!-- <vue-google-autocomplete
                            id="address"
                            label="Address *"
                            :country="['au', 'nz']"
                            class="addressbox"
                            placeholder="Address *"
                            :value="populateGuardianAddress"
                            v-on:placechanged="getGuardianAddress"
                            :rules="notNull"
                            outlined
                        >
                        </vue-google-autocomplete> -->
                        <v-google-address
                            id="address"
                            label="Address *"
                            :required="true"
                            :address="populateGuardianAddress"
                            @on-address="getGuardianAddress"
                        >
                        </v-google-address>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-6 col-no-up-down-padding">
                        <v-text-field
                            label="Mobile Number *"
                            v-model="form.guardian_mobile"
                            :rules="isPhoneNumber"
                            outlined
                            @select="disableSelection($event)"
                        ></v-text-field>
                    </v-col>
                    <v-col class="col-6 col-no-up-down-padding">
                        <v-text-field
                            ref="repeatGuardianMobile"
                            label="Repeat Mobile Number *"
                            v-model="repeat_guardian_mobile"
                            :rules="checkGuardianMobile"
                            outlined
                            @select="disableSelection($event)"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-12 col-no-up-down-padding">
                        <v-combobox
                            v-model="form.guardian_relationship"
                            :items="relationships"
                            @update:search-input="form.guardian_relationship = $event"
                            label="Relationship to you *"
                            persistent-hint
                            :rules="notNull"
                            outlined
                        ></v-combobox>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col class="col-12">
                        <div style="font-weight: bold">Emergency Contact</div>
                        <div>Is your Primary Guardian listed above also your Emergency Contact? *</div>
                        <div class="button-group-wrapper text-left">
                            <v-radio-group v-model="form.is_guardian_emergency" :value="form.is_guardian_emergency" :rules="[v => v != undefined || v != null||'Please make a selection']" row>
                            <v-radio color="#ea7f1d" label="Yes" :value="1" :style="form.is_guardian_emergency == 1 ? 'font-weight: bold;': 'font-weight: normal'"></v-radio>
                            <v-radio color="#ea7f1d" label="No" :value="0" :style="form.is_guardian_emergency == 0 ? 'font-weight: bold;': 'font-weight: normal'"></v-radio>
                            </v-radio-group>
                        </div>
                    </v-col>
                </v-row>
                <div v-if="form.is_guardian_emergency === 0">
                    <v-row>
                        <v-col class="col-5 col-no-up-down-padding">
                            <v-text-field
                                label="First Name *"
                                :value="form.emergency_first_name"
                                @input="capitalizeString($event, 'emergency_first_name')"
                                :rules="validateNationinput"
                                outlined
                            ></v-text-field>
                        </v-col>
                        <v-col class="col-7 col-no-up-down-padding">
                            <v-text-field
                                label="Last Name *"
                                :value="form.emergency_last_name"
                                @input="capitalizeString($event, 'emergency_last_name')"
                                :rules="validateNationinput"
                                outlined
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="col-12 col-no-up-down-padding">
                            <v-text-field
                                label="Email *"
                                v-model="form.emergency_email"
                                :rules="validEmail"
                                outlined
                                @select="disableSelection($event)"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="col-12 col-no-up-down-padding">
                            <v-text-field
                                ref="repeatEmergencyEmail"
                                label="Repeat Email *"
                                v-model="repeat_emergency_email"
                                :rules="checkEmergencyEmail"
                                outlined
                                @select="disableSelection($event)"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="col-12">
                            <!-- <vue-google-autocomplete
                                id="emergency_address"
                                label="Address *"
                                class="addressbox v-text-field"
                                :country="['au', 'nz']"
                                placeholder="Address *"
                                :value="populateEmergencyAddress"
                                v-on:placechanged="getEmergencyAddress"
                                :rules="notNull"
                                outlined
                            >
                            </vue-google-autocomplete>
                            <input :value="populateEmergencyAddress" :rules="v=>!!v || 'The address should not be empty'"/> -->
                            <v-google-address
                                id="emergency_address"
                                label="Address *"
                                :required="true"
                                :address="populateEmergencyAddress"
                                @on-address="getEmergencyAddress"
                            >
                            </v-google-address>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="col-6 col-no-up-down-padding">
                            <v-text-field
                                label="Mobile Number *"
                                v-model="form.emergency_mobile"
                                :rules="isPhoneNumber"
                                outlined
                                @select="disableSelection($event)"
                            ></v-text-field>
                        </v-col>
                        <v-col class="col-6 col-no-up-down-padding">
                            <v-text-field
                                ref="repeatEmergencyMobile"
                                label="Repeat Mobile Number *"
                                v-model="repeat_emergency_mobile"
                                :rules="checkEmergencyMobile"
                                outlined
                                @select="disableSelection($event)"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="col-6 col-no-up-down-padding">
                            <v-combobox
                                v-model="form.emergency_relationship"
                                @update:search-input="form.emergency_relationship = $event"
                                :items="relationships"
                                label="Relationship to you *"
                                persistent-hint
                                :rules="fullString"
                                outlined
                            ></v-combobox>
                        </v-col>
                    </v-row>
                </div>
            </v-form>
        </v-col>
    </v-row>
</template>
<script>
import Client from '../../client.js';
// import Vue from 'vue'
import axios from 'axios'
// import Auto complete google map
// import VueGoogleAutocomplete from 'vue-google-autocomplete'
import VGoogleAddress from '../VGoogleAddressComponent.vue'
import {phoneRule, hasLengthRule} from '../../utils/validationRules'

export default {
    //use as a component
    components: {VGoogleAddress},

    data: function() {
        return {
            form: {},
            relationships: ['Mother', 'Father', 'Grandmother', 'Grandfather', 'Aunt', 'Uncle', 'Friend', 'Teacher', 'Principal', 'Foster parent', 'Guardian','Other relative','Other'],
            repeat_guardian_email: null,
            repeat_guardian_mobile: null,
            repeat_emergency_email: null,
            repeat_emergency_mobile: null,
        }
    },
    async mounted() {
        if(this.$parent.childName) this.$parent.childName  = 'MY FAMILY';
        let client = Client();
        let requests = [
            client.get('me/profile'),
        ];
        let ress = await axios.all(requests);
        this.form = ress[0].data;
        if(ress[0].data) {
            this.repeat_guardian_email = ress[0].data.guardian_email;
            this.repeat_guardian_mobile = ress[0].data.guardian_mobile;
            this.repeat_emergency_email = ress[0].data.emergency_email;
            this.repeat_emergency_mobile = ress[0].data.emergency_mobile;
        }
        this.$refs.form.resetValidation();

    },
    watch: {
        'form.guardian_email'() {
            if (this.repeat_guardian_email !== null && this.repeat_guardian_email !== '') {
                this.$refs.repeatGuardianEmail.validate();
            }
        },
        'form.guardian_mobile'() {
            if (this.repeat_guardian_mobile !== null && this.repeat_guardian_mobile !== '') {
                this.$refs.repeatGuardianMobile.validate();
            }          
        },
        'form.emergency_email'() {
            if (this.repeat_emergency_email !== null && this.repeat_emergency_email !== '') {
                this.$refs.repeatEmergencyEmail.validate();
            }
        },
        'form.emergency_mobile'() {
            if (this.repeat_emergency_mobile !== null && this.repeat_emergency_mobile !== '') {
                this.$refs.repeatEmergencyMobile.validate();
            }          
        }
    },
    computed: {
        checkGuardianEmail() {
            return [
                () => this.repeat_guardian_email == this.form.guardian_email || 'Email is not the same'
            ]
        },
        checkGuardianMobile() {
            return [
                () => this.repeat_guardian_mobile == this.form.guardian_mobile || 'Mobile is not the same'
            ]
        },
        checkEmergencyEmail() {
            return [
                () => this.repeat_emergency_email == this.form.emergency_email || 'Email is not the same'
            ]
        },
        checkEmergencyMobile() {
            return [
                () => this.repeat_emergency_mobile == this.form.emergency_mobile || 'Mobile is not the same'
            ]
        },
        fullString() {
            return [
                v => v !== null && v !== undefined && v.length > 1
            ]
        },
        integer() {
            return [
                v => v !== null && v !== undefined && Number.isInteger(Number(v)) && v > 0
            ]
        },
        notNull() {
            return [
                v => v !== null && v !== undefined
            ]
        },
        validEmail() {
            return [v => /.+@\S+\.\S+/.test(v) || 'This is not a valid email address']
        },
        isPhoneNumber() {
            return [
                hasLengthRule,
                phoneRule,
            ]
        },
        notEmpty() {
            return [v => Boolean(v) && v.trim().length > 0]
        },  
        populateGuardianAddress() {
            return [this.form.guardianaddress_street_number, this.form.guardianaddress_route, this.form.guardianaddress_locality, this.form.guardianaddress_dministrative_area_level_2, this.form.guardianaddress_administrative_area_level_1, this.form.guardianaddress_country, this.form.guardianaddress_postal_code].filter(Boolean).join(", ");
        },
        populateEmergencyAddress() {
            return [this.form.emergencyaddress_street_number, this.form.emergencyaddress_route, this.form.emergencyaddress_locality, this.form.emergencyaddress_dministrative_area_level_2, this.form.emergencyaddress_administrative_area_level_1, this.form.emergencyaddress_country, this.form.emergencyaddress_postal_code].filter(Boolean).join(", ");
        },
        validateNationinput() {
            return [
                v => {
                    return v !== null
                        && v !== undefined
                        && JSON.parse(JSON.stringify(v)).length > 0
                        && this.validateNation(v);
                }
            ]
        },      
    },
    methods: {
        disableSelection(e) {
            e.target.selectionStart = e.target.selectionEnd;
        },
        capitalizeString(value, prop) {
            if(value) {
                value = value.charAt(0).toUpperCase() + value.substring(1);
            }
            this.form[prop] = value;
        },
        onChange(e) {
            console.log(e.target)
        },
        async submit() {
            let client = Client();
            console.log(this.form.emergencycontact_type)
            return await client.patch('me/profile?final=1', this.form)
                .then(() => true)
                .catch(e => {
                    if(e.response.status == 500) {
                        this.$alert(e.response.data.message)
                        return false;
                    }
                });
        },
        getGuardianAddress(guardian_address) {
            this.form.guardianaddress_street_number = guardian_address.street_number;
            this.form.guardianaddress_route=guardian_address.route;
            this.form.guardianaddress_locality=guardian_address.locality;
            this.form.guardianaddress_dministrative_area_level_2=guardian_address.administrative_area_level_2;
            this.form.guardianaddress_administrative_area_level_1=guardian_address.administrative_area_level_1;
            this.form.guardianaddress_country=guardian_address.country;
            this.form.guardianaddress_postal_code=guardian_address.postal_code;
            this.form.guardianaddress_latitude=guardian_address.latitude;
            this.form.guardianaddress_longitude=guardian_address.longitude;
            console.log(guardian_address);
        },
        getEmergencyAddress(emergency_address){
            this.form.emergencyaddress_street_number = emergency_address.street_number;
            this.form.emergencyaddress_route=emergency_address.route;
            this.form.emergencyaddress_locality=emergency_address.locality;
            this.form.emergencyaddress_dministrative_area_level_2=emergency_address.administrative_area_level_2;
            this.form.emergencyaddress_administrative_area_level_1=emergency_address.administrative_area_level_1;
            this.form.emergencyaddress_country=emergency_address.country;
            this.form.emergencyaddress_postal_code=emergency_address.postal_code;
            this.form.emergencyaddress_latitude=emergency_address.latitude;
            this.form.emergencyaddress_longitude=emergency_address.longitude;
            console.log(emergency_address);
        },
        validateNation(value1){
            var reg = /^[A-Za-z]{1,20}$/;
            if(!reg.test(value1)){
                return 'Only characters are allowed and should be shorter than 30.';
                //this.$Message.error("error string");
                //this.form.glhm = '';
            }
            return true;
        },
    }
}
</script>
<style lang="scss" scoped>
$label-line-height: 2;

.form-primary-text {
    font-family: Hind;
    color: black;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.44;
    letter-spacing: normal;
}

.form-helper-text {
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #3a3a3a;
}

.text-left {
    text-align: left;
}

.margin-right {
    margin-right: 10px;
}

.primary-guardian {
  width: 401px;
  height: 30px;
  color: black;
}

.row-height-80{
    height: 80px;
}

.row-margin-bottom-40
{
    margin-bottom: 40px;
}

.col-no-up-down-padding
{
    padding-top: 0;
    padding-bottom: 0;
}

#abc>label{
    overflow: visible;
    white-space: normal;
}


</style>